import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        maxWidth: 480,
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
      }}>
        <div style={{ fontSize: 72, marginBottom: 16 }}>❌</div>
        <h1 style={{ color: '#e65100', margin: '0 0 12px', fontSize: 28, fontWeight: 700 }}>
          Payment Cancelled
        </h1>
        <p style={{ color: '#555', fontSize: 16, margin: '0 0 28px' }}>
          Your payment was cancelled and you have not been charged. You can try again anytime.
        </p>
        <div style={{ display: 'flex', gap: 12, flexDirection: 'column' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: '#1976d2', color: '#fff', border: 'none',
              borderRadius: 10, padding: '14px 32px',
              fontWeight: 700, fontSize: 16, cursor: 'pointer',
            }}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
